import {Fragment} from "preact";
import s from "./emptyResults.module.css";
import {useEmptyResults} from "./useEmptyResults";
import { useAppContext } from "../../../contexts";

const EmptyResults = () => {
    // Component logic data
    const componentProps = useEmptyResults();

    // Destructured component logic data
    const {handleClearFilters} = componentProps;

    const {highContrast} = useAppContext(); 

    return (
        <Fragment>
            <div className={s.emptyCatalogRoot}>
                <h3 className={`${s.emptyCatalogTitle} ${highContrast ? "highTitleFirst" : ""}`}>
                    Lamentamos, não foi possível encontrar nenhum serviço relacionado as categorias selecionadas:
                </h3>
                <ul className={`${s.tipsList} ${highContrast ? "highList" : ""}`}>
                    <li>Verifique os filtros que foram marcados;</li>
                    <li>Use menos combinações;</li>
                    <li>Encontre o serviço que você procura através da nossa busca.</li>
                </ul>
                <button
                    type={"button"}
                    className={`${s.clearCategoriesButton} ${highContrast ? "highFormButtonSecond" : ""}`}
                    onClick={() => handleClearFilters()}
                >
                    Limpar filtros
                </button>
            </div>
        </Fragment>
    )
}

export default EmptyResults;
